
export function getShare (data) {
    //判断环境
    let u = navigator.userAgent
    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        window.jxyy.shareWebpageUrl(data.webpageUrl, data.title, data.description, data.thumbUrl)
    } else if (isiOS) {
        window.webkit.messageHandlers.shareWebpageUrl.postMessage(data);
    }
}
